// extracted by mini-css-extract-plugin
export var avatarContainer = "_3z-1";
export var largeAvatarContainer = "_3z-2";
export var smallAvatarContainer = "_3z-0";